type WindowEnhanced = Window &
  typeof globalThis & {
    REACT_APP_ELASTIC_APM_SERVICE_NAME?: string;
    REACT_APP_ELASTIC_APM_SERVER_URL?: string;
    REACT_APP_ELASTIC_APM_ENVIRONMENT?: string;
    REACT_APP_IMAGE_VERSION?: string;
    REACT_APP_STATIC_URL?: string;
    REACT_APP_CAREER_PAGE_URL?: string;
    REACT_APP_ELASTIC_APM_PAGE_LOAD_TRACE_ID?: string;
    REACT_APP_ELASTIC_APM_PAGE_LOAD_SPAN_ID?: string;
    REACT_APP_ELASTIC_APM_USER_ID?: string;
    REACT_APP_ELASTIC_APM_USERNAME?: string;
    REACT_APP_ELASTIC_APM_USER_EMAIL?: string;
    REACT_APP_ELASTIC_APM_TENANT?: string;
    REACT_APP_ELASTIC_APM_PAGE_LOAD_SAMPLED?: boolean;
    REACT_APP_AUTH_DOMAIN?: string;
    REACT_APP_AUTOSAVE_DELAY?: string;
    REACT_APP_ENABLE_MINDSTEM_STYLES?: string;
    REACT_APP_MINDSIGHT_SYSTEM_URL?: string;
    REACT_APP_GTM_ID?: string;
    REACT_APP_LANGUAGE_COOKIE_NAME?: string;
    REACT_APP_LANGUAGE_AUTODETECT?: string;
    REACT_APP_QUERY_STALE_TIME?: string;
  };

const envSettings = window as WindowEnhanced;
export default class Config {
  static REACT_APP_ELASTIC_APM_SERVICE_NAME =
    process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME ||
    envSettings.REACT_APP_ELASTIC_APM_SERVICE_NAME;
  static REACT_APP_ELASTIC_APM_SERVER_URL =
    process.env.REACT_APP_ELASTIC_APM_SERVER_URL || envSettings.REACT_APP_ELASTIC_APM_SERVER_URL;
  static REACT_APP_ELASTIC_APM_ENVIRONMENT =
    process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT || envSettings.REACT_APP_ELASTIC_APM_ENVIRONMENT;
  static REACT_APP_IMAGE_VERSION =
    process.env.REACT_APP_IMAGE_VERSION || envSettings.REACT_APP_IMAGE_VERSION;
  static REACT_APP_STATIC_URL =
    process.env.REACT_APP_STATIC_URL || envSettings.REACT_APP_STATIC_URL || '';
  static REACT_APP_CAREER_PAGE_URL =
    process.env.REACT_APP_CAREER_PAGE_URL || envSettings.REACT_APP_CAREER_PAGE_URL || '';
  static REACT_APP_ELASTIC_APM_PAGE_LOAD_TRACE_ID =
    envSettings.REACT_APP_ELASTIC_APM_PAGE_LOAD_TRACE_ID;
  static REACT_APP_ELASTIC_APM_PAGE_LOAD_SPAN_ID =
    envSettings.REACT_APP_ELASTIC_APM_PAGE_LOAD_SPAN_ID;
  static REACT_APP_ELASTIC_APM_PAGE_LOAD_SAMPLED =
    envSettings.REACT_APP_ELASTIC_APM_PAGE_LOAD_SAMPLED;
  static REACT_APP_ELASTIC_APM_USER_ID = envSettings.REACT_APP_ELASTIC_APM_USER_ID;
  static REACT_APP_ELASTIC_APM_USERNAME = envSettings.REACT_APP_ELASTIC_APM_USERNAME;
  static REACT_APP_ELASTIC_APM_USER_EMAIL = envSettings.REACT_APP_ELASTIC_APM_USER_EMAIL;
  static REACT_APP_ELASTIC_APM_TENANT = envSettings.REACT_APP_ELASTIC_APM_TENANT;
  static REACT_APP_AUTH_DOMAIN =
    process.env.REACT_APP_AUTH_DOMAIN || envSettings.REACT_APP_AUTH_DOMAIN || '';
  static REACT_APP_AUTOSAVE_DELAY =
    Number(process.env.REACT_APP_AUTOSAVE_DELAY) ||
    Number(envSettings.REACT_APP_AUTOSAVE_DELAY) ||
    1000;
  static REACT_APP_MINDSIGHT_SYSTEM_URL =
    process.env.REACT_APP_MINDSIGHT_SYSTEM_URL || envSettings.REACT_APP_MINDSIGHT_SYSTEM_URL || '';
  static REACT_APP_ENABLE_MINDSTEM_STYLES =
    process.env.REACT_APP_ENABLE_MINDSTEM_STYLES || envSettings.REACT_APP_ENABLE_MINDSTEM_STYLES;
  static REACT_APP_GTM_ID = process.env.REACT_APP_GTM_ID || envSettings.REACT_APP_GTM_ID;
  static REACT_APP_LANGUAGE_COOKIE_NAME =
    process.env.REACT_APP_LANGUAGE_COOKIE_NAME || envSettings.REACT_APP_LANGUAGE_COOKIE_NAME;
  static REACT_APP_LANGUAGE_AUTODETECT =
    process.env.REACT_APP_LANGUAGE_AUTODETECT || envSettings.REACT_APP_LANGUAGE_AUTODETECT;
  static REACT_APP_QUERY_STALE_TIME =
    Number(process.env.REACT_APP_QUERY_STALE_TIME) ||
    Number(envSettings.REACT_APP_QUERY_STALE_TIME) ||
    0;
}
